import { render } from "./DisableModal.vue?vue&type=template&id=787680c6&scoped=true"
import script from "./DisableModal.vue?vue&type=script&lang=js"
export * from "./DisableModal.vue?vue&type=script&lang=js"

import "./DisableModal.vue?vue&type=style&index=0&id=787680c6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787680c6"]])

export default __exports__